import { Pipe, PipeTransform } from '@angular/core';
import { AsicStatus } from '@models/documents/asic-status.enum';

@Pipe({
  standalone: true,
  name: 'asicStatus'
})
export class AsicStatusPipe implements PipeTransform {
  transform(value: AsicStatus | undefined): string {
    switch (value) {
      case AsicStatus.NotLodged:
        return 'Not Lodged';
      case AsicStatus.WaitingForASIC:
        return 'Waiting For ASIC';
      case AsicStatus.FutureLodgement:
        return 'Future Lodgement';
      case AsicStatus.ManualProcessing:
        return 'Manual Processing';
      default:
        return AsicStatus[value as AsicStatus] ?? '-';
    }
  }
}
